module.exports = __webpack_public_path__ + "img/consecuencia2.bf07b522.png";